import { userConstants } from './constants';

export const userActions = (status) => (dispatch) => {
  dispatch({ type: userConstants.LOGIN_REQUEST, payload: status });
};
